module.exports = __webpack_public_path__ + "static/media/Strike_defence_Cluster_01.6b920fec.jpg";